/* =================================================================
   5. State
   ================================================================= */
export const state = {
  selectedModels: new Set(
    // Default picks for a fresh visitor with no saved selection: one OpenAI
    // (gpt-4o still current in the 2026 catalog) + one Anthropic (Claude
    // Sonnet 5, the current Balanced tier). Users with an existing
    // `lp_aiboard_selected` in localStorage keep whatever they had — the
    // MODEL_ID_ALIASES map in data/models.ts routes legacy ids (e.g.
    // claude-sonnet-4-6) to their Claude 5 successor at dispatch time, so
    // no one gets a "model not found" error mid-session.
    JSON.parse(localStorage.getItem('lp_aiboard_selected') || '["gpt-4o","claude-sonnet-5"]')
  ),
  lastResponses: [] as any[],
  lastPrompt: '',
  /* Full history of synthesis calls in this session — pushed on every
   * synth + every Continue → so a saved session can faithfully replay
   * the whole consolidation arc, not just the latest text. */
  syntheses: [] as Array<{
    mode: string;
    model_id: string;
    text: string;
    truncated?: boolean;
    is_continuation?: boolean;
    created_at: string;
  }>,
  /* Exports the user actually produced (md/docx/pdf/pptx-*). Metadata
   * only — bytes already left the page via the user's Save-As. */
  deliverables: [] as Array<{
    kind: string;
    name: string;
    title?: string;
    created_at: string;
  }>,
  /* Backend interaction id (returned by /api/history/interaction on the
   * fan-out). Lets a restored session attach synth + deliverables to
   * the same row when the user keeps working. */
  lastInteractionId: '' as string,
  /* User-uploaded attachments queued for the next fan-out. Survives
   * across runs until the user clears them. Persisted in the snapshot
   * (base64 for binary, text for text) so a restored session puts the
   * same files back on the prompt. */
  promptAttachments: [] as Array<{
    id: string;
    name: string;
    mime: string;
    size: number;
    /* 'text' = read as UTF-8 string, prepended to prompt. Works for every model.
     * 'image' = base64 PNG/JPG/WEBP/GIF, sent as vision part to models that support it.
     * 'pdf'   = base64 PDF, sent natively to models that support it (Anthropic + Gemini).
     * 'binary'= caught but unparseable in v1; kept in snapshot for round-trip but
     *           the model only sees a note about it. */
    kind: 'text' | 'image' | 'pdf' | 'binary';
    text?: string;
    base64?: string;
    /* For text attachments derived from DOCX/PPTX: the original file's
     * MIME stays here so the chip can show e.g. .docx even though the
     * payload is now text. */
    sourceMime?: string;
  }>,
};

/* Stash so saveSynthesis / saveOptimal know what to write */
export const savedState = {
  lastSynthText: '',
  lastSynthMode: '',
  lastSynthModelId: '',
  lastSynthTruncated: false,
  lastOptimalPrompt: '',
};
